import { render, staticRenderFns } from "./power-site-manage.vue?vue&type=template&id=09475a47&scoped=true&"
import script from "./power-site-manage.vue?vue&type=script&lang=js&"
export * from "./power-site-manage.vue?vue&type=script&lang=js&"
import style0 from "./power-site-manage.vue?vue&type=style&index=0&id=09475a47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09475a47",
  null
  
)

export default component.exports